/* Draw a strike line on sold-out sizes by reading availability from the product JSON */
(() => {
  const BRA = /\b\d{2}[A-Z]\b/i;                            // e.g. 14F
  const up = s => (String(s || '').trim().toUpperCase());

  // mark all size labels based on a map { "14F": true/false }
  function makeMarker(sizeAvail) {
    return function mark() {
      // find every radio that looks like a size (value matches a known size)
      const radios = Array.from(document.querySelectorAll('input[type="radio"]'));
      radios.forEach(inp => {
        const val = up(inp.value);
        if (!(val in sizeAvail)) return;                    // not a size option
        const lab = document.querySelector(`label[for="${inp.id}"]`);
        if (!lab) return;
        const available = !!sizeAvail[val];
        lab.classList.toggle('is-soldout', !available);
      });
    };
  }

  async function init() {
    // 1) fetch current product JSON
    let product;
    try {
      const res = await fetch(location.pathname.replace(/\/+$/,'') + '.js', { credentials: 'same-origin' });
      product = await res.json();
    } catch (e) {
      return;                                              // bail quietly if fetch fails
    }

    // 2) build a map of Size (option1) -> availability
    const sizeAvail = {};
    (product.variants || []).forEach(v => {
      // some stores format as "14F / 32F" — normalize by extracting the bra code
      const m = String(v.option1 || '').match(BRA);
      const key = up(m ? m[0] : v.option1);
      if (key) sizeAvail[key] = !!v.available;
    });

    // 3) mark now and on DOM updates (Broadcast can re-render)
    const mark = makeMarker(sizeAvail);
    const mo = new MutationObserver(() => mark());
    mo.observe(document.body, { subtree: true, childList: true });

    document.addEventListener('change', () => setTimeout(mark, 0), true);

    // expose helpers for quick console checks
    window.__strikeInit = true;
    window.__strikeMark = mark;

    mark();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
